export const context = {
    title: "Achats",
    none: "Aucun achat pour le moment.",
    more: {
        title: "Chargez plus d'achats",
        label: "plus d'achats"
    }
}